<template>
    <div class="page">
        <van-nav-bar
            title="隐私政策"
            left-arrow
            fixed
            placeholder
            safe-area-inset-top
            @click-left="goBack"
        />
        <iframe
            class="policy-frame"
            :src="policyUrl"
            title="隐私政策"
        />
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicy',
    data() {
        return {
            policyUrl: '/static-h5/privacyPolicy.html',
        }
    },
    methods: {
        goBack() {
            this.$router.back()
        },
    },
}
</script>

<style scoped>
.page {
    display: flex;
    flex-direction: column;
    height: 100vh;
    height: 100dvh;
    background: #eef3f9;
    box-sizing: border-box;
}

.policy-frame {
    flex: 1;
    width: 100%;
    border: none;
    background: #eef3f9;
}

.page ::v-deep .van-nav-bar {
    background: #ffffff;
}

.page ::v-deep .van-nav-bar .van-nav-bar__title {
    color: #1e3a5f;
    font-weight: 600;
}

.page ::v-deep .van-nav-bar .van-icon {
    color: #2b7de9;
}
</style>
